import Actions from 'actions'
import Operations from 'operations'
import type { AnyAction } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

/**
 * The V1 modal's redux form. The facelift page keeps the same shape in local
 * state instead (`useAddMedicationForm`).
 */
export const ADD_MEDICATION_FORM_ID = 'addEmarMedication'

type RoundDetails = {
  isChecked?: boolean
  dose?: unknown
  altDose?: unknown
}

/** The fields read by name; the steps write many more. */
export type AddMedicationFields = {
  PRN?: boolean | null
  controlledDrug?: boolean | null
  /** DD-MM-YYYY */
  startDate?: string
  /** DD-MM-YYYY */
  endDate?: string
  hasEndDate_comment?: string
  emarRoundsDetails?: RoundDetails[]
  [key: string]: unknown
}

/** What the form tracks besides its fields. */
export type AddMedicationFormState = {
  /** The NHS medication picked, or the custom name typed. */
  medicationName?: string
  [key: string]: unknown
}

/** Starts an empty add medication form for the resident. */
export const createAddMedicationForm = (residentId: string) =>
  Actions.addForm({
    formId: ADD_MEDICATION_FORM_ID,
    initial: { resident: residentId }
  })

/** Reloads the redux lists a new medication shows up in. */
export const reloadMedicationLists =
  ({
    emarV2ChartEnabled,
    emarV2RoundTimings
  }: {
    emarV2ChartEnabled: boolean
    emarV2RoundTimings: boolean
  }) =>
  (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
    dispatch(
      Operations.loadEmarRoundTimings({
        useV2Endpoints: emarV2RoundTimings,
        legacyUrl: emarV2ChartEnabled
          ? '/emar/legacy/emar-round-timings'
          : undefined
      })
    )
    dispatch(
      emarV2ChartEnabled
        ? Operations.loadList(
            'emar-resident-medications',
            undefined,
            true,
            '/emar/medication-schedule-patterns/legacy/emar-resident-medications'
          )
        : Operations.loadList('emar-resident-medications')
    )
  }
